import BaseService from '@/services/base.service';
import { singleTicket } from '@/resources/loto';
const API_URL = process.env.VUE_APP_API_URL;

class LottoService extends BaseService {
    generateTickets(number: number) {
        const numbers = Array(number).fill(number).map((_, index) => index + 1);
        const tickets: any[] = [];
        numbers.forEach((t, i) => {
            tickets.push(JSON.parse(JSON.stringify(singleTicket)));
        });

        return tickets;
    }
    generateCode(type: string, bets: Array<any>) {
        return this.post(API_URL+'/lotto/api/generateCode', {
            type: type,
            bet: bets
        }).then((response) => {
            return response.data;
        });

        return false;
    }
    scanQrCode(code: string) {
        return this.post(API_URL+'/pos/api/scanQrCode', {
            code
        }).then((response) => {
            return response.data;
        });
        return false;
    }
    scanTicket(ref: string) {
        return this.post(API_URL+'/pos/api/scanTicket', {
            ref
        }).then((response) => {
            return response.data;
        });
        return false;
    }
    confirmTicket(type: string, wager: number, bet: Array<any>) {
        return this.post(API_URL+'/pos/api/confirmTicket', {
            type,
            wager,
            bet
        }).then((response) => {
            return response.data;
        });
        return false;
    }
    checkScanInput(scanInput: string) {
        return this.post(API_URL+'/pos/api/checkScanInputType', {
            scanInput
        }).then((response) => {
            return response.data;
        });
        return false;
    }
}

export default new LottoService();